(function() {
  if (window.FpHomeV2Booted) return;
  window.FpHomeV2Booted = true;

  function embedUrl(url) {
    if (!url) return "";
    if (url.indexOf("youtube.com/watch") !== -1) {
      try {
        var youtubeUrl = new URL(url);
        var videoId = youtubeUrl.searchParams.get("v");
        if (videoId) return "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0";
      } catch (error) {}
    }
    if (url.indexOf("youtu.be/") !== -1) {
      var shortId = url.split("youtu.be/")[1];
      if (shortId) return "https://www.youtube.com/embed/" + shortId + "?autoplay=1&rel=0";
    }
    if (url.indexOf("vimeo.com/") !== -1) {
      var vimeoId = url.split("vimeo.com/")[1];
      if (vimeoId) return "https://player.vimeo.com/video/" + vimeoId + "?autoplay=1";
    }
    return url;
  }

  function lockScroll(dialog) {
    if (dialog) {
      document.documentElement.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
    }
  }

  function initModal() {
    var dialog = document.getElementById("FpHomeVideoModal");
    if (!dialog) return;

    var embed = dialog.querySelector("[data-fp-home-modal-embed]");
    var closeButton = dialog.querySelector("[data-fp-home-modal-close]");
    var loader = dialog.querySelector("[data-fp-home-modal-loader]");
    var activeTrigger = null;

    function setLoading(isLoading) {
      dialog.classList.toggle("is-loading", !!isLoading);
      if (loader) loader.setAttribute("aria-hidden", String(!isLoading));
    }

    function wireMediaReadyState(mediaElement) {
      if (!mediaElement) {
        setLoading(false);
        return;
      }

      if (mediaElement.tagName === "IFRAME") {
        mediaElement.addEventListener("load", function() {
          setLoading(false);
        }, { once: true });
        return;
      }

      if (mediaElement.tagName === "VIDEO") {
        var onReady = function() {
          setLoading(false);
        };
        mediaElement.addEventListener("loadeddata", onReady, { once: true });
        mediaElement.addEventListener("canplay", onReady, { once: true });
      }
    }

    function closeModal() {
      if (embed) embed.innerHTML = "";
      setLoading(false);
      dialog.close();
      lockScroll(false);
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
    }

    document.querySelectorAll("[data-fp-home-video-trigger]").forEach(function(trigger) {
      trigger.addEventListener("click", function() {
        var url = trigger.getAttribute("data-video-url");
        if (!url) {
          var fallback = trigger.getAttribute("data-video-fallback");
          if (fallback) window.location.href = fallback;
          return;
        }

        activeTrigger = trigger;
        setLoading(true);
        var normalizedUrl = embedUrl(url);
        if (normalizedUrl.indexOf("youtube.com/embed") !== -1 || normalizedUrl.indexOf("player.vimeo.com/video/") !== -1) {
          embed.innerHTML = '<iframe src="' + normalizedUrl + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Freedompro video"></iframe>';
        } else {
          embed.innerHTML = '<video src="' + normalizedUrl + '" controls autoplay playsinline></video>';
        }
        wireMediaReadyState(embed.querySelector("iframe, video"));
        dialog.showModal();
        lockScroll(true);
        if (closeButton) closeButton.focus();
      });
    });

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    dialog.addEventListener("click", function(event) {
      var rect = dialog.getBoundingClientRect();
      var inDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
      if (!inDialog) closeModal();
    });

    dialog.addEventListener("close", function() {
      if (embed) embed.innerHTML = "";
      setLoading(false);
      lockScroll(false);
    });

    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape" && dialog.open) {
        event.preventDefault();
        closeModal();
      }
    });
  }

  function initFaq() {
    document.querySelectorAll(".fp-home-faq__button").forEach(function(button) {
      button.addEventListener("click", function() {
        var panelId = button.getAttribute("aria-controls");
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        var isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isExpanded));
        panel.hidden = isExpanded;
      });
    });
  }

  function initHeroVideo() {
    document.querySelectorAll("[data-fp-home-hero-video]").forEach(function(root) {
      var video = root.querySelector("video");
      var toggle = root.querySelector("[data-fp-home-audio-toggle]");
      if (!video || !toggle) return;

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        video.pause();
      }

      toggle.addEventListener("click", function() {
        video.muted = !video.muted;
        toggle.setAttribute("aria-pressed", String(!video.muted));
        toggle.setAttribute("aria-label", video.muted ? "Attiva audio video" : "Disattiva audio video");
      });
    });
  }

  function initBestsellers() {
    document.querySelectorAll("[data-fp-home-bestsellers]").forEach(function(section) {
      var track = section.querySelector("[data-fp-home-bestseller-track]");
      if (!track) return;

      var prevButton = section.querySelector("[data-bestseller-nav='prev']");
      var nextButton = section.querySelector("[data-bestseller-nav='next']");

      function updateNav() {
        if (!prevButton || !nextButton) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 4;
        prevButton.disabled = track.scrollLeft <= 4;
        nextButton.disabled = track.scrollLeft >= maxScroll;
      }

      function scrollByCard(direction) {
        var card = track.querySelector(".fp-home-bestsellers__card");
        var amount = card ? card.getBoundingClientRect().width + 14 : 320;
        track.scrollBy({ left: amount * direction, behavior: "smooth" });
      }

      if (prevButton) prevButton.addEventListener("click", function() { scrollByCard(-1); });
      if (nextButton) nextButton.addEventListener("click", function() { scrollByCard(1); });
      track.addEventListener("scroll", updateNav, { passive: true });
      window.addEventListener("resize", updateNav);
      updateNav();

      section.querySelectorAll("[data-fp-home-add-to-cart]").forEach(function(button) {
        button.addEventListener("click", function() {
          if (button.disabled) return;
          var variantId = button.getAttribute("data-variant-id");
          if (!variantId) return;

          var originalLabel = button.textContent;
          button.disabled = true;

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }]
            })
          }).then(function(response) {
            if (!response.ok) throw new Error("cart_add_failed");
            return response.json();
          }).then(function() {
            button.textContent = "✓ Aggiunto";
            setTimeout(function() {
              button.textContent = originalLabel;
              button.disabled = false;
            }, 1800);
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }).catch(function() {
            button.textContent = "Errore";
            setTimeout(function() {
              button.textContent = originalLabel;
              button.disabled = false;
            }, 1800);
          });
        });
      });
    });
  }

  function initMiniVideosSlider() {
    document.querySelectorAll("[data-fp-home-mini-videos-grid]").forEach(function(grid) {
      var section = grid.closest(".fp-home-mini-videos");
      var cards = Array.prototype.slice.call(grid.querySelectorAll(".fp-home-mini-videos__card"));
      var dots = section ? Array.prototype.slice.call(section.querySelectorAll("[data-mini-video-dot]")) : [];
      if (!cards.length || !dots.length) return;

      function setActiveDot(index) {
        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle("is-selected", dotIndex === index);
        });
      }

      function currentIndex() {
        var gridLeft = grid.getBoundingClientRect().left;
        var index = 0;
        var closest = Number.POSITIVE_INFINITY;

        cards.forEach(function(card, cardIndex) {
          var distance = Math.abs(card.getBoundingClientRect().left - gridLeft);
          if (distance < closest) {
            closest = distance;
            index = cardIndex;
          }
        });

        return index;
      }

      var ticking = false;
      function syncDots() {
        if (window.innerWidth > 767) {
          setActiveDot(0);
          ticking = false;
          return;
        }
        setActiveDot(currentIndex());
        ticking = false;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncDots);
      }

      dots.forEach(function(dot) {
        dot.addEventListener("click", function() {
          var index = Number(dot.getAttribute("data-mini-video-dot"));
          if (!cards[index]) return;
          cards[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
        });
      });

      grid.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", syncDots);
      syncDots();
    });
  }

  function initWhyEditorialCarousel() {
    document.querySelectorAll("[data-fp-home-why-carousel]").forEach(function(carousel) {
      var slider = carousel.querySelector(".fp-home-why-editorial__slider");
      if (!slider) return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll("[data-fp-home-why-slide]"));
      var interval = Number(carousel.getAttribute("data-fp-home-why-carousel-interval")) || 2800;
      var timer = null;
      var index = 0;
      var dragState = {
        active: false,
        pointerId: null,
        startX: 0,
        deltaX: 0
      };

      function pad(value) {
        return String(value).padStart(2, "0");
      }

      function mod(value, length) {
        return (value % length + length) % length;
      }

      function render(progress) {
        progress = progress || 0;
        slides.forEach(function(slide, slideIndex) {
          var forwardOrder = mod(slideIndex - index, slides.length);
          var offset = forwardOrder - progress;

          var absOffset = Math.abs(offset);
          var clampedDepth = Math.min(absOffset, 3);
          var translateX = offset < 0 ? offset * 20 : offset * 22;
          var translateY = clampedDepth * 14;
          var scale = 1 - clampedDepth * 0.045;
          var rotate = offset * 0.45;
          var opacity = absOffset > 3 ? 0 : Math.max(0.2, 1 - clampedDepth * 0.17);
          var blur = Math.max(0, clampedDepth - 0.3) * 0.45;
          var zIndex = 1000 - Math.round(absOffset * 100);

          if (offset < -1) {
            translateX -= 22;
            opacity *= 0.42;
          }

          if (offset > 0.9) {
            translateY += Math.min(offset, 3) * 4;
          }

          if (absOffset < 0.08) {
            zIndex = 1200;
          } else if (offset > 0) {
            zIndex -= 40;
          }

          slide.style.transform = "translate3d(" + translateX + "px, " + translateY + "px, 0) scale(" + scale + ") rotate(" + rotate + "deg)";
          slide.style.opacity = String(opacity);
          slide.style.filter = "blur(" + blur + "px)";
          slide.style.zIndex = String(zIndex);
          slide.style.boxShadow = absOffset < 0.35
            ? "0 26px 52px rgba(15, 23, 42, 0.14), 0 10px 22px rgba(148, 163, 184, 0.12)"
            : "0 18px 34px rgba(15, 23, 42, 0.08), 0 6px 14px rgba(148, 163, 184, 0.08)";
        });

      }

      function goTo(nextIndex) {
        if (!slides.length) return;
        index = mod(nextIndex, slides.length);
        render(0);
      }

      function advance() {
        if (slides.length < 2) return;
        goTo(index + 1);
      }

      function start() {
        if (timer || slides.length < 2) return;
        timer = window.setInterval(advance, interval);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function startDrag(event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (!slides.length) return;
        event.preventDefault();
        dragState.active = true;
        dragState.pointerId = event.pointerId;
        dragState.startX = event.clientX;
        dragState.deltaX = 0;
        slider.classList.add("is-dragging");
        stop();
        if (slider.setPointerCapture && event.pointerId != null) {
          slider.setPointerCapture(event.pointerId);
        }
      }

      function moveDrag(event) {
        if (!dragState.active || dragState.pointerId !== event.pointerId) return;
        event.preventDefault();
        var width = slider.clientWidth || 1;
        dragState.deltaX = event.clientX - dragState.startX;
        render(Math.max(-1, Math.min(1, -dragState.deltaX / width)));
      }

      function endDrag(event) {
        if (!dragState.active || (event.pointerId != null && dragState.pointerId !== event.pointerId)) return;
        var width = slider.clientWidth || 1;
        var progress = Math.max(-1, Math.min(1, -dragState.deltaX / width));

        dragState.active = false;
        dragState.pointerId = null;
        slider.classList.remove("is-dragging");
        if (slider.releasePointerCapture && event.pointerId != null && slider.hasPointerCapture && slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }

        if (progress > 0.16) {
          goTo(index + 1);
        } else if (progress < -0.16) {
          goTo(index - 1);
        } else {
          render(0);
        }

        start();
      }

      render(0);
      start();

      window.addEventListener("resize", function() {
        render(0);
      });
      carousel.addEventListener("mouseenter", stop);
      carousel.addEventListener("mouseleave", start);
      carousel.addEventListener("focusin", stop);
      carousel.addEventListener("focusout", start);
      slider.addEventListener("pointerdown", startDrag);
      slider.addEventListener("pointermove", moveDrag);
      slider.addEventListener("pointerup", endDrag);
      slider.addEventListener("pointercancel", endDrag);
      slider.addEventListener("dragstart", function(event) {
        event.preventDefault();
      });
      slides.forEach(function(slide) {
        slide.setAttribute("draggable", "false");
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initModal();
    initFaq();
    initHeroVideo();
    initBestsellers();
    initMiniVideosSlider();
    initWhyEditorialCarousel();
  });
})();
